import React from "react";
import { css } from "aphrodite";
import { styles } from "src/styles/Tooltip";

export class CombinedToolTip extends React.Component<any> {

    public render() {
        const label = this.props.label;
        const labelName = this.props.labelName;
        let value1;
        let value2;
        let value3;

        try{
            const payload = this.props.payload[0];
            if(payload !== undefined){
                value1 = payload.value;
            }else{
                value1 = "";
            }
        }catch(err){
            value1 = "";
        }

        try{
            const payload = this.props.payload[1];
            if(payload !== undefined){
                value2 = payload.value;
            }else{
                value2 = "";
            }
        }catch(err){
            value2 = "";
        }

        try{
            const payload = this.props.payload[2];
            if(payload !== undefined){
                value3 = payload.value;
            }else{
                value3 = "";
            }
        }catch(err){
            value3 = "";
        }

        if(this.props.valueFormatter !== undefined){
            value1 = this.props.valueFormatter(value1);
            value2 = this.props.valueFormatter(value2);
            value3 = this.props.valueFormatter(value3);
        }

        return (
            <div className={css(styles.tooltip)} >
                <div>
                    {labelName}: {label}
                </div>
                <div>
                    {"Proposals"}: {value2}
                </div>
                <div>
                    {"Awards"}: {value1}
                </div>
                <div>
                    {"Expenditures"}: {value3}
                </div>
            </div>
            
        );
    }
}




// WEBPACK FOOTER //
// ./src/components/CombinedTooltip.tsx